<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import { mapGetters, mapActions } from 'vuex'
import AttachmentItem from './AttachmentItem'

export default {
  name: 'FilesOverlay',
  components: {
    AttachmentItem,
  },
  props: {
    isOpen: Boolean,
    files: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      maximumRecordsToShow: 8,
    }
  },
  computed: {
    ...mapGetters('groups', ['canDeleteGroup']),
    opened: {
      set() {
        this.$emit('onCloseOverlay')
      },
      get() {
        return this.isOpen
      },
    },
    showMore() {
      return this.maximumRecordsToShow < this.files.length
    },
  },
  methods: {
    ...mapActions('posts', ['deleteFile']),
    viewMore() {
      this.maximumRecordsToShow += 8
    },
    async removeFile(file) {
      await this.deleteFile(file.id)
      this.$emit('onDeleteFile')
    },
  },
}
</script>
